/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ImportAuctionStartingBidCsvRowConflictType {
  InvalidLotNumber = 'invalid_lot_number',
  InvalidStartingBid = 'invalid_starting_bid',
  LotNumberNotFound = 'lot_number_not_found',
  DuplicateLotNumber = 'duplicate_lot_number'
}
